import { parse } from 'date-fns';
import { BuyerIntelligenceVehicleModel } from 'types/Apis/BuyerIntelligenceVehicle';
import { BuyerIntelligenceViewModel, RealTimePriceChange } from './types';

class BuyerIntelligencePresenter implements BuyerIntelligenceViewModel {
  private vehicle: BuyerIntelligenceVehicleModel;

  constructor(vehicle: BuyerIntelligenceVehicleModel) {
    this.vehicle = vehicle;
  }

  get price(): number {
    return this.vehicle.price;
  }

  get timeOnMarket(): number | null {
    return this.vehicle.time_on_market;
  }

  get realTimePriceChanges(): RealTimePriceChange[] {
    return (this.vehicle.real_time_price_changes || [])
      .map((priceChange) => {
        const date = parse(priceChange.date, 'yyyy-MM-dd', new Date());

        return {
          ...priceChange,
          date,
        };
      })
      .reverse();
  }

  get relativePriceDiff(): number {
    return this.vehicle.relative_price_difference;
  }

  get totalPriceChange(): number | null {
    return this.vehicle.total_price_change;
  }
}

export default BuyerIntelligencePresenter;
